import { createAction } from 'redux-actions';


export const restoreDraftState = createAction('RESTORE_DRAFT_STATE');
export const keepDraftState = createAction('KEEP_DRAFT_STATE');



// WEBPACK FOOTER //
// ./src/shared/actions/draft.js